


















































import AppSvgIcon from '@/uikit/components/AppSvgIconNew/AppSvgIcon.vue';
import AppTooltip from '@/uikit/components/AppTooltip/AppTooltip';
export default {
  name: 'OrdersStat',
  components: {
    AppSvgIcon,
    AppTooltip,
  },
  props: {
    orders_stat: {
      required: true,
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/orders-stat/OrdersStat.vue